<template>
    <div>
        <el-cascader
            style="width:100%;"
            :props="props"
            clearable
            placeholder="请选择所在区域"
            :value="value"
            filterable
            :options="options"
            @input="$emit('input', $event)"
        />
    </div>
</template>


<script>
import citys from '@/utils/city.js'
export default {
    name:'NfCityCascader',
    props:{
        value:{
            type:Array,
            default:()=>[],
            required:true
        }
    },
    data() {
        return {
            props: {
                expandTrigger: 'hover'
            },
            options:citys
        }
    }
};
</script>